import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { first } from 'rxjs';
import { AppLoaderService } from 'src/app/services/app-loader/app-loader.service';
import { CryptoJsService } from 'src/app/services/crypto-js.service';
import { FarmersDetailsService } from 'src/app/services/farmers-details.service';
import { VendorDashboardService } from 'src/app/services/vendor-dashboard.service';

@Component({
  selector: 'app-grievance',
  templateUrl: './grievance.component.html',
  styleUrls: ['./grievance.component.scss']
})
export class GrievanceComponent implements OnInit {
  @ViewChild('grievanceDataTable') tableContainer: ElementRef;
  grievanceForm: FormGroup;
  userTypes = [
    { label: 'Farmer', value: 'farmer' },
    { label: 'Vendor', value: 'vendor' },
    // { label: 'Helpdesk', value: 'helpdesk' }
  ];

  loginType: string = '';  // Assuming this value will be set based on the login type
  public subscriptions: any = []
  public subjectSub: any;
  public grievanceTableData: any = [];
  public vendorCode: any;
  public farmerMobileNo: any;
  public categoryList: any = [];

  constructor(
    private fb: FormBuilder,
    private messageService: MessageService,
    private _personalDetalSer: FarmersDetailsService,
    private loader: AppLoaderService,
    private vendorService: VendorDashboardService,
    private cryptoJsService: CryptoJsService
  ) { }

  ngOnInit(): void {
    const encData = JSON.parse(this.cryptoJsService.DecryptSession(sessionStorage.getItem('dataF')));
    const farmerconfData = new Map(encData);
    const mobileNo = farmerconfData.get('farmerPh') ? farmerconfData.get('farmerPh') : '';
    const isFarmerLogin =  farmerconfData.get('isFarmerLogin')

    const encDataD = sessionStorage.getItem('dataD') ? JSON.parse(this.cryptoJsService.DecryptSessionD(sessionStorage.getItem('dataD'))) : null;
    const loginDetails = new Map(encDataD);
    const isVendorLogin = loginDetails.get('isVendor') ? loginDetails.get('isVendor') : null;


    this.loginType = isFarmerLogin == '1' ? 'farmer' : isVendorLogin == '1' ? 'vendor' : '';

    const isDisabled = this.loginType === 'farmer' || this.loginType === 'vendor';

    this.grievanceForm = this.fb.group({
      userType: [{ value: this.loginType, disabled: isDisabled }, Validators.required],
      userName: ['', Validators.required],
      mobileNumber: [{ value: '', disabled: this.loginType == 'farmer' ? true : false }, [Validators.required, Validators.pattern('^[0-9]{10}$')]],
      emailId: ['', [Validators.required, Validators.email]],
      address: [''],
      description: ['', Validators.required],
      category: ['', Validators.required],
      grievanceCopyPath: [null, Validators.required]
    });

    if (this.loginType == 'farmer') {
      this.farmerMobileNo = mobileNo;
      this.grievanceForm.controls.mobileNumber.setValue(mobileNo)
    } else if (this.loginType == 'vendor') {
      const token: any = JSON.parse(this.cryptoJsService.DecryptToken(sessionStorage.getItem('token')));
      let payload = atob(token?.authToken?.split('.')[1]);
      // this.vendorCode = JSON.parse(payload)?.sub;
      this.vendorCode = JSON.stringify(token?.officeCode);

      // this.vendorRegId = JSON.stringify(token?.officeCode);
    }

    this.loadCategory();
  }

  loadCategory(){
    this.loader.start();
    let sub = this.vendorService
      .getCategories()
      .pipe(first())
      .subscribe({
        next: (data) => {
          this.loader.close();

          if (data.length > 0) {
            this.categoryList = data;
          } else {
            this.categoryList = [];
            this.messageService.add({
              severity: 'info',
              summary: 'Info Message',
              detail: `${data}`,
            });
          }

        },
        error: (err) => {
          this.categoryList = [];
          this.loader.close();
          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: err,
          });
        },
      });

    this.subscriptions.push(sub);
  }


  onFileChange(event: any) {
    const file = event.target.files[0];
    if (file && file.size <= 5 * 1024 * 1024) { // 5 MB limit
      this.grievanceForm.patchValue({ file: file });
    } else {
      this.grievanceForm.patchValue({ file: null });
      alert('File size exceeds 5 MB.');
    }
  }

  onSubmit() {
    if (this.grievanceForm.valid) {
      // console.log('Form submitted', this.grievanceForm.value);
      let val = this.grievanceForm.value;

      let phoneNo = null;
      if (this.loginType == 'farmer') {
        let phNo = this.farmerMobileNo;
        phoneNo = phNo;
      }else if(this.loginType == 'vendor'){
        phoneNo = val?.mobileNumber
      }
     
      let reqBody = {
        "user_Id": this.loginType,
        "user_Name": val?.userName,
        "mobile_No": phoneNo,
        "address": val?.address,
        "emailID": val?.emailId,
        "briefDescription": val?.description,
        "grievanceType": val?.category,
        "doc_Path": val?.grievanceCopyPath,
        "vendor_Code": this.vendorCode ? this.vendorCode : '0'
      }
      this.postGrievanceData(reqBody);
      // Here you can handle form submission, like sending the data to a server
    } else {
      alert('Please fill in all required fields.');
      this.markAllFieldsAsTouched();
    }
  }

  private markAllFieldsAsTouched() {
    Object.keys(this.grievanceForm.controls).forEach(field => {
      const control = this.grievanceForm.get(field);
      control?.markAsTouched({ onlySelf: true });
    });
  }

  onUpload(event, formcontrol, uploadElement) {
    let file = event.files[0];
    let data = new FormData();
    data.append('file', file);
    let phNo = this.farmerMobileNo;
    this.loader.start();

    this._personalDetalSer.uploadFile(data, phNo, formcontrol).subscribe(
      (resp: any) => {
        this.loader.close();
        if (resp.statusCode == 200) {
          this.grievanceForm.patchValue({ [formcontrol]: resp.data });
          this.messageService.add({
            severity: 'success',
            summary: 'Success',
            detail: 'File Uploaded Successfully',
          });
        } else {
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: 'Oops! Someting went wrong.',
          });
        }
      },
      (err) => {
        this.loader.close();
        this.messageService.add({
          severity: 'error',
          summary: 'Error Message',
          detail: err,
        });
      }
    );
    uploadElement.clear();
  }

  onClickTrackApp() {
    this.grievanceTableData = [];
    if (this.loginType == 'vendor') {
      this.getVendorGrievanceDetails(this.vendorCode);
      // this.getVendorGrievanceDetails(0);
    } else if (this.loginType == 'farmer') {
      this.getFarmerGrievanceDetails(this.farmerMobileNo);
      // this.getFarmerGrievanceDetails('string');
    }
  }

  postGrievanceData(reqBody) {
    this.loader.start();
    let sub = this.vendorService
      .submitGrievance(reqBody)
      .pipe(first())
      .subscribe({
        next: (data) => {
          this.loader.close();

          if (data.startsWith('Your ticket')) {
            this.messageService.add({
              severity: 'success',
              summary: 'Success Message',
              detail: `${data}`,
            });
            this.grievanceForm.reset();
          } else {
            this.messageService.add({
              severity: 'info',
              summary: 'Info Message',
              detail: `${data}`,
            });
          }

        },
        error: (err) => {
          this.loader.close();
          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: err,
          });
        },
      });

    this.subscriptions.push(sub);
  }

  getVendorGrievanceDetails(vendorCode) {
    this.loader.start();
    let sub = this.vendorService
      .vendorGrievanceStatus(vendorCode)
      .pipe(first())
      .subscribe({
        next: (data) => {
          this.loader.close();

          if (data.length > 0) {
            this.grievanceTableData = data;
            setTimeout(() => this.tableContainer.nativeElement.scrollIntoView({
              block: "center",
              behavior: "smooth"
            }), 400)
          } else {
            this.grievanceTableData = [];
            this.messageService.add({
              severity: 'info',
              summary: 'Info Message',
              detail: 'Data Not Found',
            });
          }

        },
        error: (err) => {
          this.loader.close();
          this.grievanceTableData = [];

          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: err,
          });
        },
      });

    this.subscriptions.push(sub);
  }

  getFarmerGrievanceDetails(mobileNo) {
    this.loader.start();
    let sub = this.vendorService
      .farmerGrievanceStatus(mobileNo)
      .pipe(first())
      .subscribe({
        next: (data) => {
          this.loader.close();

          if (data.length > 0) {
            this.grievanceTableData = data;
            setTimeout(() => this.tableContainer.nativeElement.scrollIntoView({
              block: "center",
              behavior: "smooth"
            }), 400)
          } else {
            this.grievanceTableData = [];
            this.messageService.add({
              severity: 'info',
              summary: 'Info Message',
              detail: 'Data Not Found',
            });
          }

        },
        error: (err) => {
          this.loader.close();
          this.grievanceTableData = [];

          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: err,
          });
        },
      });

    this.subscriptions.push(sub);
  }

  ngOnDestroy() {
    this.subscriptions.forEach(sub => sub.unsubscribe());
    if (this.subjectSub) {
      this.subjectSub.unsubscribe();
    }
  }

  getSeverity(status: any) {
    if (status.startsWith('A')) {
      return 'warning'
    } else if (status.startsWith('C')) {
      return 'success';
    }
  }
}
